import { c as _c } from "react/compiler-runtime";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import React from "react";
dayjs.extend(utc);
import { FormError } from "@/TS/Interfaces/global_interfaces";
interface TimePickerProps {
  className?: string;
  label?: string;
  error?: FormError;
}
function TimePickerContainer(t0) {
  const $ = _c(18);
  let className;
  let error;
  let label;
  let rest;
  if ($[0] !== t0) {
    ({
      label,
      className,
      error,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = error;
    $[3] = label;
    $[4] = rest;
  } else {
    className = $[1];
    error = $[2];
    label = $[3];
    rest = $[4];
  }
  const t1 = "flex flex-col gap-1 " + (className ?? "");
  let t2;
  if ($[5] !== label) {
    t2 = <p className="text-md font-bold">{label}</p>;
    $[5] = label;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = ["hours", "minutes"];
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      openPickerIcon: {
        className: "text-secondary"
      },
      actionBar: {
        className: "!text-event"
      },
      digitalClockSectionItem: {
        className: "hover:bg-event !selected:bg-event hover:bg-opacity-10 text-event "
      }
    };
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== rest) {
    t5 = <TimePicker label={undefined} className="text-event " views={t3} format="HH:mm" ampm={false} slotProps={t4} {...rest} />;
    $[9] = rest;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== error) {
    t6 = error?.err && <p className="text-primary text-sm mt-1">{error.message}</p>;
    $[11] = error;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t1 || $[14] !== t2 || $[15] !== t5 || $[16] !== t6) {
    t7 = <div className={t1}>{t2}{t5}{t6}</div>;
    $[13] = t1;
    $[14] = t2;
    $[15] = t5;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  return t7;
}
export default TimePickerContainer;